/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]{padding:6px 13px}.info-label[_ngcontent-%COMP%]{text-align:left;width:136px;font-weight:700}\n/*# sourceMappingURL=dynamic-view-question.component.css.map*/"];
export { styles as styles };
